// src/components/info/ContactInfo.jsx
import React from 'react';
import styles from './ContactInfo.module.css';
import listStyles from './ContactInfo.module.css';
import useAccessibility from 'hooks/useAccessibility';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";

const ContactInfo = ({ footerData }) => {
  const accessibilityVariant = useAccessibility();

  if (!footerData) return null;
  const phoneNumber = footerData.phone;

  return (
    <div
      className={`${listStyles.container} ${listStyles[accessibilityVariant]}`}
      aria-labelledby="contact-info-title"
    >
      <div className={listStyles.content}>
        <div className={listStyles.block}>
          {/* On injecte le HTML du champ coordonnee (si on veut des sauts de ligne, etc.) */}
          <div
            dangerouslySetInnerHTML={{ __html: footerData.coordonnee ?? '' }}
          />

          {/* Si vous préférez juste afficher du texte :
              <p>{footerData.coordonnee}</p> */}

          <a
            href={`tel:${phoneNumber}`}
            aria-label={`Téléphoner au Pharos ${phoneNumber}`}
            title="Téléphoner au Pharos"
          >
            {phoneNumber}
          </a>

          <a
              href="mailto:pharos@ville-arras.fr"
              aria-label="Envoyer un email au pharos"
              title="Envoyer un email au pharos"
          >
            pharos@ville-arras.fr
          </a>


        </div>

        <div className={listStyles.block}>
          {/* Même chose pour openHours */}

        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
